import React, { useRef }  from 'react';
import { Icon } from 'semantic-ui-react';
import "../../Courses/stylesheets/profileHeader.css";
import '../../Courses/stylesheets/headerStyles.css';
import outsideClickDetector from '../../Shared Components/outsideClickDetector';

export default function Profile({ userHandle, logoutUrl, onClose }) {
    const wrapperRef = useRef(null);
    outsideClickDetector(wrapperRef, onClose);

    const menus = [
        {
          icon: <Icon name="user" />,
          text: "My Profile",
          url: `${process.env.REACT_APP_AUTH_URL}/user/${userHandle}/practice`,
        },
        {
          icon: <Icon name="book" />,
          text: "My Courses",
          url: "/myCourses",
        },
        // {
        //   icon: <Icon name="chat" />,
        //   text: "Discussions",
        //   url: "/discussion/all/",
        // },
        {
          icon: <Icon name="chart bar" />,
          text: "Leaderboard",
          url: "/leaderboard",
        },
        {
          icon: <Icon name="redo" />,
          text: "My Transactions",
          url: "/transactions",
        },
        {
          text: "Edit Profile",
          icon: <Icon name="pencil" />,
          url: `${process.env.REACT_APP_AUTH_URL}/edit-profile.php`,
        },
        {
          text: "Logout",
          icon: <Icon name="sign-out" />,
          url: `${process.env.REACT_APP_AUTH_URL}/logout.php?to=${window.location.href}`,
        },
      ];

    return (
        <div className="custom-popup-container" ref={wrapperRef}>
            {menus.map((item) => (
                <a className="menu-item" href={item.url}>
                   <span className="item">{item.icon}</span> {item.text}
                </a>
            ))}
        </div>
    )
}
